import React from 'react';
import {
  IconChevronDown,
  IconBuildingBank,
  IconChevronUp,
} from '@tabler/icons-react';

import { RenderBankLogo } from './RenderBankPaymentMethod';
import { TypeCardPaymentMethod, PaymentResultData } from 'pages/types';
import MethodVa from 'components/MethodVa';
import MethodCard from 'components/MethodCard';
import MethodEWallet from 'components/MethodEWallet';
import MethodDirectDebit from 'components/MethodDirectDebit';
import MethodQR from 'components/MethodQR';

const CardPaymentMethod: React.FC<
  TypeCardPaymentMethod & {
    phoneNumber?: string;
    setPhoneNumber?: (value: string) => void;
    setDataPayment: (value: PaymentResultData) => void;
    setPickPayment: (value: boolean) => void;
    type: string;
  }
> = ({
  dataImg,
  name,
  type,
  icon = <IconBuildingBank className="w-[22px] h-[22px] text-gray-800" />,
  isOpen = false,
  onToggle,
  setDataPayment,
  setPickPayment,
  settings,
}) => {
  if (!dataImg || !dataImg.length) {
    return <div />;
  }

  return (
    <div>
      <div
        className="flex flex-row justify-between items-center border border-gray-300 py-3 px-3.5 cursor-pointer select-none"
        onClick={onToggle}
      >
        <div className="flex flex-row gap-3 items-center">
          {icon}
          <span className="text-base font-semibold text-gray-800">{name}</span>
        </div>

        <div className="flex flex-row gap-2 items-center">
          <div className="flex flex-row justify-between gap-2 items-center">
            {dataImg
              ?.filter(
                (item, index, self) =>
                  index === self.findIndex((t) => t.code === item.code)
              )
              .slice(0, 3)
              .map((items, idx) => (
                <RenderBankLogo
                  title={items.id === 0 ? 'QRIS' : items.code}
                  key={items.id || idx}
                  idx={idx}
                />
              ))}
          </div>

          {isOpen ? (
            <IconChevronUp className="w-6 h-6 text-gray-800" />
          ) : (
            <IconChevronDown className="w-6 h-6 text-gray-800" />
          )}
        </div>
      </div>

      {isOpen && (
        <div className="border-b border-l border-r border-gray-300 py-3 px-3.5 select-none">
          <div>
            {type === 'VIRTUAL_ACCOUNT' && (
              <MethodVa
                data={dataImg}
                settings={settings}
                setDataPayment={setDataPayment}
                setPickPayment={setPickPayment}
              />
            )}

            {type === 'CARD' && (
              <MethodCard
                data={dataImg}
                settings={settings}
                setDataPayment={setDataPayment}
                setPickPayment={setPickPayment}
              />
            )}

            {type === 'E-WALLET' && (
              <MethodEWallet
                data={dataImg}
                settings={settings}
                setDataPayment={setDataPayment}
                setPickPayment={setPickPayment}
              />
            )}

            {type === 'DIRECT_DEBIT' && (
              <MethodDirectDebit
                data={dataImg}
                settings={settings}
                setDataPayment={setDataPayment}
                setPickPayment={setPickPayment}
              />
            )}

            {type === 'QRIS' && (
              <MethodQR
                data={dataImg}
                settings={settings}
                setDataPayment={setDataPayment}
                setPickPayment={setPickPayment}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CardPaymentMethod;
